var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarketingServicesBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: #333;\n      }\n\n      .cls-2 {\n        opacity: .2;\n      }\n\n      .cls-3 {\n        opacity: .5;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 1200,
    height: 1200
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 306,
    y: 600,
    width: 175,
    height: 350
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 512.5,
    y: 425,
    width: 175,
    height: 525
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 719,
    y: 250,
    width: 175,
    height: 700
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingServicesBlack);
export default __webpack_public_path__ + "static/media/marketingServicesBlack.3258294b927e5411915bb5f27fd5f663.svg";
export { ForwardRef as ReactComponent };